/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Airport } from '../../models/airport';
import { BaseResponse } from '../../models/base-response';
import { DtoCreateAirport } from '../../models/dto-create-airport';

export interface CommonControllerCreateAirport$Params {
      body: DtoCreateAirport
}

export function commonControllerCreateAirport(http: HttpClient, rootUrl: string, params: CommonControllerCreateAirport$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: Airport;
}>> {
  const rb = new RequestBuilder(rootUrl, commonControllerCreateAirport.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: Airport;
      }>;
    })
  );
}

commonControllerCreateAirport.PATH = '/common/airports';
